import { Box } from "@material-ui/core";
import { useMemo } from "react";
import AreaChart from "src/components/ScoringChart/AreaChart";
import { defaultYAxisConfig } from "src/components/ScoringChart/BaseChartStyle";
import { beautifulTooltip } from "src/components/ScoringChart/tool-utils/BeautifulTooltip";
import TitleTypography from "src/components/Typography/TitleTypography";
import ScoringLoading from "src/components/utils/ScoringLoading";
import PaperWrapper from "src/components/Wrapper/PaperWrapper";
import { useAnalysisSelector } from "src/context/analysisContext";
import { useWeb3Connect } from "src/wallet-connection/context/we3-connect-context";

const getOption = (yAxisConfig) => ({
  chart: {
    height: 280,
  },
  xAxis: {
    type: "datetime",
  },
  yAxis: yAxisConfig,
  ...beautifulTooltip((value) => value),
});

export default function CreditScoreHistoryChart() {
  const history = useAnalysisSelector((state) => state.account?.history);
  const { address } = useWeb3Connect();

  const series = useMemo(() => {
    if (history) {
      let dataChart = history.map((element) => {
        return [element[0] * 1000, element[1]];
      });
      return [{ name: "Score", data: [...dataChart] }];
    } else return [{ name: "Score", data: [] }];
  }, [history]);

  const yAxisConfig = useMemo(() => {
    if (history) {
      let maxValue = 0;
      for (var point of history) {
        if (maxValue < point[1]) maxValue = point[1];
      }
      return { ...defaultYAxisConfig, ...{ min: 0, max: maxValue } };
    }
    return defaultYAxisConfig;
  });

  return (
    <PaperWrapper
      title="Your Credit Score History"
      style={{ marginTop: "1.5rem" }}
      paperProps={{ style: { height: 310 } }}
    >
      {(() => {
        if (address) {
          if (history) return <AreaChart series={series} option={getOption(yAxisConfig)} />;
          else return <ScoringLoading />;
        } else
          return (
            <Box display="flex" justifyContent="center" alignItems="center" height="100%">
              <TitleTypography textProps={{ variant: "h4" }} title="Please connect your wallet first!" />
            </Box>
          );
      })()}
    </PaperWrapper>
  );
}
